const COMPACT_SELECTED_UPLOAD_PATCH = Symbol.for('eInvitation.photoAlbumCompactSelectedUpload.v1')

function collectUploadForms(root = document) {
  const forms = new Set()

  if (root instanceof Element) {
    if (root.matches('.epa-upload-form')) forms.add(root)
    const closest = root.closest('.epa-upload-form')
    if (closest) forms.add(closest)
  }

  root.querySelectorAll?.('.epa-upload-form').forEach((form) => forms.add(form))
  return [...forms]
}

function syncUploadForm(form) {
  const selectedCount = form.querySelectorAll('.epa-preview-item').length
  const hasSelection = selectedCount > 0
  const dropZone = form.querySelector('.epa-upload-drop')

  form.classList.toggle('epa-upload-has-selection', hasSelection)

  if (dropZone) {
    const label = hasSelection ? 'Add more photos' : 'Choose or drag photos here'
    dropZone.setAttribute('aria-label', label)
    dropZone.title = hasSelection ? label : ''
  }
}

function syncUploadForms(root = document) {
  collectUploadForms(root).forEach(syncUploadForm)
}

export function installPhotoAlbumCompactSelectedUpload() {
  if (typeof document === 'undefined' || globalThis[COMPACT_SELECTED_UPLOAD_PATCH]) return

  const start = () => {
    syncUploadForms(document)

    const observer = new MutationObserver((mutations) => {
      const affectedForms = new Set()

      for (const mutation of mutations) {
        const targetForm = mutation.target instanceof Element
          ? mutation.target.closest('.epa-upload-form')
          : null
        if (targetForm) affectedForms.add(targetForm)

        for (const node of [...mutation.addedNodes, ...mutation.removedNodes]) {
          if (!(node instanceof Element)) continue
          const form = node.matches('.epa-upload-form')
            ? node
            : node.closest('.epa-upload-form') || node.querySelector('.epa-upload-form')
          if (form) affectedForms.add(form)
        }
      }

      affectedForms.forEach(syncUploadForm)
    })

    observer.observe(document.documentElement, { childList: true, subtree: true })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true })
  } else {
    start()
  }

  globalThis[COMPACT_SELECTED_UPLOAD_PATCH] = true
}
